import {ModuleState} from '@gongxigames/framework/slot/fragments/module/ModuleState';
import {PromotionCounterModule, PromotionCounterView} from '@gongxigames/framework/slot/modules/promotionsCounter';
import {CounterData} from '@gongxigames/framework/promotions';
import {strictUiEmitter} from '@gongxigames/framework/slotV2/globals';

export class PromotionCounterActiveState extends ModuleState<PromotionCounterView, PromotionCounterModule> {
    public onEnterState(): void {
        this.showCounter();
        this.emit('General.UI.HideElement', {name: 'TotalBetOpen'});
    }

    public onLeaveState(): void {
        this.emit('General.UI.ShowElement', {name: 'TotalBetOpen'});
        this.hideCounter();
    }

    protected setupEvents(): void {
        this.setEventHandler('General.Promotion.ShowCounter', this.showCounter.bind(this));
        this.setEventHandler('General.Promotion.HideCounter', this.hideCounter.bind(this));
        this.setEventHandler('General.Promotion.UpdateCounter', this.updateCounter.bind(this));
        this.setEventHandler('General.Promotion.DeactivateCounter', this.onDeactivateCounter.bind(this));

        strictUiEmitter.on('UI.menu.closed', this.onStrictShowCounter.bind(this));
        strictUiEmitter.on('UI.menu.opened', this.onStrictHideCounter.bind(this));
        strictUiEmitter.on('UI.menu.gameRulesClicked', this.onStrictHideCounter.bind(this));
        strictUiEmitter.on('UI.menu.infoPageClicked', this.onStrictHideCounter.bind(this));
    }

    protected onStrictShowCounter(): void {
        if (this.isStateActive) {
            this.showCounter();
        }
    }

    protected onStrictHideCounter(): void {
        if (this.isStateActive) {
            this.hideCounter();
        }
    }

    protected get isStateActive(): boolean {
        return this.module.currentState?.name === this.name;
    }

    protected showCounter(): void {
        this.view.showCounter();
    }

    protected hideCounter(): void {
        this.view.hideCounter();
    }

    protected updateCounter(data: CounterData): void {
        this.view.updateCounter(data);
    }

    protected onDeactivateCounter(): void {
        this.module.gotoState(PromotionCounterModule.BASIC_STATE);
    }
}
